import i18n from 'i18next';

export const DEFAULT_ADVANCED_CONFIG = {
  tracking: { detector_type: 'human' },
  rate: {
    unit: {
      value: 'frame',
      get label() {
        return i18n.t('lunaApi:константы.video analytics.sending type.frame');
      },
    },
    period: 1,
  },
  face_samples: {
    count: 5,
    filters: {
      score: 0.6,
      head_yaw: 15,
      head_roll: 15,
      head_pitch: 15,
    },
  },
  probe_count: 3,
};

export const TARGET_CONFIG = {
  liveness: ['face_detection', 'aggregated_liveness'],
  deepfake: ['face_detection', 'aggregated_deepfake', 'aggregated_face_detection_sources'],
  face: ['face_detection', 'emotions', 'glasses', 'mask', 'aggregated_face_basic_attributes'],
  body: ['aggregated_body_attributes', 'body_detection'],
};
